var React = require('react');

function EtteMobileMenu1 (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"st0","d":"M0,1.7c3.1,0.4,5.4,0.9,7.8,1.2C10.2,3,12.6,3,15.6,2.6c2.7-0.2,8.2,0.5,11,1.1C28.4,4,30.1,4.1,31.9,4\n\tc0.7,0,1.5,0.3,2.1-1.1c-2.5-0.1-5-0.6-7.6-0.7C23,2,19.7,0.5,16.3,0.2c-4.6-0.4-7.7-0.2-10.1,0C3.7,0.5,2,1.1,0,1.7"}));
}

EtteMobileMenu1.defaultProps = {"x":"0px","y":"0px","viewBox":"0 0 34 4"};

module.exports = EtteMobileMenu1;

EtteMobileMenu1.default = EtteMobileMenu1;
